import EnduranceTrainingTypeManagement from '../../../components/enduranceTrainingType/EnduranceTrainingTypeManagement';
import { ReactElement } from 'react';

const SuperAdminEnduranceTrainingTypes = (): ReactElement => {
  return (
    <EnduranceTrainingTypeManagement mode="superAdmin" />
  )
}

export default SuperAdminEnduranceTrainingTypes